// Domain 03 — Routing Technologies (RouteZero Southern Regional Network, Davao City)
import u01 from './u01-routing-fundamentals.js';
import u02 from './u02-static-routes.js';
import u03 from './u03-default-routes.js';
import u04 from './u04-floating-static.js';
import u05 from './u05-rip.js';
import u06 from './u06-ospf-fundamentals.js';
import u07 from './u07-ospf-config.js';
import u08 from './u08-ospf-ts.js';
import u09 from './u09-eigrp-fundamentals.js';
import u10 from './u10-eigrp-config.js';
import u11 from './u11-eigrp-ts.js';
import u12 from './u12-bgp-fundamentals.js';
import u13 from './u13-ebgp.js';
import u14 from './u14-final.js';

export default {
  id: 'd03', number: '03', title: 'Routing Technologies',
  tagline: 'Routing tables, static and default routes, floating statics, RIP, OSPF, EIGRP and eBGP across RouteZero\'s southern region.',
  units: [u01, u02, u03, u04, u05, u06, u07, u08, u09, u10, u11, u12, u13, u14],
};
